import React, { useLayoutEffect, useRef } from 'react'
import { Text, TextProps } from '@chakra-ui/react'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

type EllipsisWithTippyProps = TextProps & {
  tippyText: string
  width?: string
}

/**
 * if the tag is wider than parent, adds a tooltip for the user to be able to see the whole text
 */
export const EllipsisWithTippy: React.FC<EllipsisWithTippyProps> = ({
  tippyText,
  width,
  ...chakraProps
}) => {
  const ref = useRef<HTMLParagraphElement>(null)

  useLayoutEffect(() => {
    const element = ref.current
    if (element && element.scrollWidth > element.clientWidth) {
      tippy(element)
    }
  }, [ref.current])

  return (
    <Text
      {...chakraProps}
      width={width}
      display="inline-block"
      className="overflowEllipsis dark"
      ref={ref}
      data-tippy-content={tippyText}
      data-tippy-placement={'bottom-start'}
    />
  )
}
